export default __webpack_public_path__ + "static/media/investors-other.a30d9ae1.wav";